import React from 'react';
import { Typography, Space } from 'antd';
import { AppstoreOutlined } from '@ant-design/icons';
import FeeTierManager from '../components/FeeTierManager';

const { Title, Text } = Typography;

const FeeTiers = () => {
  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: '24px' }}>
        <Space>
          <AppstoreOutlined style={{ fontSize: '24px', color: '#1890ff' }} />
          <Title level={2} style={{ margin: 0 }}>
            Fee Tiers Management
          </Title>
        </Space>
        <Text type="secondary" style={{ display: 'block', marginTop: '8px' }}>
          Kelola konfigurasi fee bertingkat berdasarkan jumlah transaksi untuk setiap merchant dan produk pembayaran.
          Sistem akan secara otomatis memilih tier yang sesuai berdasarkan jumlah transaksi dan priority tier.
        </Text>
      </div>

      <FeeTierManager />
    </div>
  );
};

export default FeeTiers;